import JSRouter from "adminPage/JSRouter";
import FormValidator from "base/FormValidator";
import Message from "base/Message";
import ConfirmModal from "modal/ConfirmModal";
import AddressesEditor from "websiteUsers/AddressesEditor";
import Ajax from "base/Ajax";
import queryString from "query-string";

JSRouter.register('websiteUsers', /([0-9a-f]+)\/?/, (url_args, userData, get_args) => {
    let $form = $(".js-website-user-form");

    let addressEditor = new AddressesEditor(userData !== null ? userData.addresses : null, userData !== null ? userData : null);
    $(".js-address-editor-wrap").html(addressEditor.$element);

    addressEditor.on("submit", () => $form.submit());

    FormValidator.attach($form).on("submit", ($form) => {
        if (!addressEditor.validate()) return;

        let $btn = $(".js-update-btn");
        if ($btn.is(".admin-btn--loading")) return;
        $btn.addClass("admin-btn--loading");

        Ajax.post("websiteUsers", (url_args[0] === "add" ? "" : url_args[0]), $form.serializeJSON()).then((user) => {
            addressEditor.user = user;
            return addressEditor.save().then(() => user);
        }).then((user) => {
            if (url_args[0] === "add") {
                Message.schedule(new Message('User Added successfully', '', Message.SUCCESS));
                if (get_args.next) {
                    let a = document.createElement('a');
                    a.href = get_args.next;
                    let searchParts = queryString.parse(a.search);
                    searchParts['user'] = user.id;

                    a.search = queryString.stringify(searchParts);

                    window.location.href = a.href;
                } else {
                    window.location.href = user.links.edit;
                }
            } else {
                new Message('User updated successfully', '', Message.SUCCESS);
                $btn.removeClass("admin-btn--loading");
            }
        }).catch((e) => {
            $btn.removeClass("admin-btn--loading");
            new Message(e.message, "Couldn't update this user");
        })
    });

    $("body").on("click", ".js-delete-user", function () {
        ConfirmModal.confirm('Are you sure want to remove this user?', undefined, {showLoading: true}).then((done) => {
            Ajax.delete("websiteUsers", url_args[0]).then(() => {
                Message.schedule(new Message('User deleted successfully', '', Message.SUCCESS));
                window.location.href = window.CONFIG.urls.admin + 'websiteUsers';
            }).catch((e) => {
                new Message(e.message, "Couldn't delete this user");
                done();
            })
        });

        return false;
    }).on("click", ".js-reset-password", function () {
        ConfirmModal.confirm("Are you sure want to reset this user's password? They won't be able to log in until they change it.", undefined, {showLoading: true}).then((done) => {
            Ajax.post("websiteUsers", url_args[0] + "/resetPassword").then(() => {
                new Message("", "User password reset successfully", Message.SUCCESS);
                done();
            }).catch((e) => {
                new Message(e.message, "Couldn't reset the user's password");
                done();
            })
        });

        return false;
    }).on("click", ".js-update-btn", () => {
        $form.submit();
        return false;
    });
});
